import '../../node_modules/swiper/swiper-bundle.js';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function () {

    const swiperMobile = new Swiper(".swiper-mobile", {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 20,
        loop: true,
        mousewheel: true,
    });

    const swiperDesktop = new Swiper(".swiper-desktop", {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 20,
        loop: false,
        mousewheel: true,
        freeMode: true,
    });

}
